import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, OverlayTrigger, Popover } from 'react-bootstrap';
import {
  colours as colourHelpers,
  installer as installerHelpers,
  scenarios as scenarioConstants,
  unicode as unicodeHelpers
} from './../helpers';
import ConditionalComponent from './ConditionalComponent';

const baseStyle = {
  float: 'left',
  textAlign: 'center',
  padding: '10px',
  'fontSize': '1vw'
};

export const failColor = {
  color: colourHelpers.colours.red,
  outline: '2px solid red',
  ...baseStyle
};

export const successColor = {
  color: colourHelpers.colours.blue,
  outline: '2px solid rgb(0,166,216)',
  ...baseStyle
};

export const skipColor = {
  color: colourHelpers.colours.orange,
  outline: '2px solid orange',
  ...baseStyle
};

export const unknownColor = {
  color: colourHelpers.colours.black,
  outline: '2px solid black',
  ...baseStyle
};

export const badPackColor = {
  color: colourHelpers.colours.purple,
  outline: '2px solid purple',
  ...baseStyle
};

export default class InstallerTestInfoComponent extends React.Component {
  static propTypes = {
    metrics: PropTypes.object.isRequired,
    badPrePack: PropTypes.bool,
    badPostPack: PropTypes.bool,
    title: PropTypes.string.isRequired,
    scenarioStatus: PropTypes.string.isRequired
  };

  getResultVerdict(resultMetric) {
    const metric = resultMetric.toUpperCase();
    if (metric === 'TRUE' || metric === scenarioConstants.SCENARIO_COMPLETED) {
      return {
        isSuccess: true,
        display: scenarioConstants.SCENARIO_COMPLETED,
        color: successColor
      };
    }
    if (metric === scenarioConstants.SCENARIO_SKIPPED) {
      return {
        isSuccess: false,
        display: scenarioConstants.SCENARIO_SKIPPED,
        color: skipColor
      };
    }

    if (metric === 'FALSE' || metric === scenarioConstants.SCENARIO_FAILED) {
      return {
        isSuccess: false,
        display: scenarioConstants.SCENARIO_FAILED,
        color: failColor
      };
    }

    // default to unknown
    return {
      isSuccess : false,
      display: scenarioConstants.SCENARIO_UNKNOWN,
      color: unknownColor
    };
  }

  getArrowCol(key) {
    return (
      <Col md={1} key={key}>
        <h1 style={{ 'textAlign': 'center', 'fontSize': '2vw', marginLeft: '20px' }}>
          {unicodeHelpers.RIGHT_ARROW}
        </h1>
      </Col>
    );
  }

  render() {
    const {
      metrics,
      scenarioStatus
    } = this.props;

    // get the interpreted scenario status from the metrics
    const scenarioVerdict = installerHelpers
      .scenarioVerdictFromMetrics(metrics, scenarioStatus);
    if (![scenarioConstants.SCENARIO_COMPLETED, scenarioConstants.SCENARIO_FAILED]
      .includes(scenarioVerdict))
    {
      return null;
    }

    // the scenario result is used as the verdict for white tests ran
    metrics[installerHelpers.WHITE_TEST_RESULT] = scenarioStatus;
    const filteredMetrics = installerHelpers.INSTALLER_TEST_METRIC_KEYS.filter(
      key => metrics[key.concat(installerHelpers.RESULT_KEY)]);

    const columns = filteredMetrics.map((key) => {
      const resultKey = key.concat(installerHelpers.RESULT_KEY);
      const expectedKey = key.concat(installerHelpers.EXPECTED_KEY);
      const actualKey = key.concat(installerHelpers.ACTUAL_KEY);

      const resultVerdict = this.getResultVerdict(metrics[resultKey]);
      // if showing delta pack results, and the delta pack is bad, then ovveride the verdict
      if ((key === installerHelpers.PRE_UPDATE_KEY && this.props.badPrePack) ||
        (key === installerHelpers.POST_UPDATE_KEY && this.props.badPostPack))
      {
        resultVerdict.color = badPackColor;
        resultVerdict.display = 'Bad Delta Pack';
      }
      return (
        <Col md={1} key={key}>
          <OverlayTrigger overlay={
            <Popover id={'popover-' + key} title={'Result'} >
              {resultVerdict.display}
            </Popover>
          }
          >
            <h4 style = {resultVerdict.color} >
              {installerHelpers.INSTALLER_TEST_METRICS_PRETTY_NAMES[key]}
              <br />
              <ConditionalComponent
                condition={!!(metrics[expectedKey] && metrics[actualKey])}
              >
                <ConditionalComponent
                  condition={resultVerdict.isSuccess}
                  children={
                    <div>
                      Version:
                      <br />
                      {metrics[expectedKey]}
                    </div>}
                  elseChildren={
                    <div>
                      Expected:
                      <br />
                      {metrics[expectedKey]}
                      <br />
                      Actual:
                      <br />
                      {metrics[actualKey]}
                    </div>}
                />
              </ConditionalComponent>
            </h4>
          </OverlayTrigger>
        </Col>
      );
    });

    for (let i = 1; i < columns.length; i += 2) {
      columns.splice(i, 0, this.getArrowCol('arrowCol-' + i.toString()));
    }

    return (
      <div>
        <Row>
          {columns}
        </Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// src/Components/InstallerTestInfoComponent.jsx